import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "none" }, [
      _createElementVNode("path", {
        fill: "#FFE16B",
        d: "M11.5 4.075c-3.985 0-7.216 3.245-7.216 7.246a7.24 7.24 0 0 0 4.961 6.88v4.44h.902V24h2.706v-1.358h.902V18.2a7.24 7.24 0 0 0 4.96-6.88c0-4-3.23-7.245-7.215-7.245M11.5 0a.45.45 0 0 0-.451.453v1.811a.451.451 0 1 0 .902 0V.453A.45.45 0 0 0 11.5 0m10.824 10.868H20.52a.45.45 0 0 0-.451.453c0 .25.201.453.45.453h1.805c.249 0 .45-.203.45-.453a.45.45 0 0 0-.45-.453m-19.844 0H.676a.45.45 0 0 0-.45.453c0 .25.201.453.45.453H2.48c.25 0 .451-.203.451-.453a.45.45 0 0 0-.45-.453zm16.355-7.552-1.276 1.28a.454.454 0 0 0 .32.773c.115 0 .23-.044.318-.132l1.275-1.281a.454.454 0 0 0 0-.64.45.45 0 0 0-.637 0M4.803 17.405l-1.275 1.28a.454.454 0 0 0 .318.774.45.45 0 0 0 .32-.133l1.275-1.28a.454.454 0 0 0 0-.641.45.45 0 0 0-.638 0m13.394 0a.45.45 0 0 0-.638 0 .454.454 0 0 0 0 .64l1.276 1.28a.45.45 0 0 0 .637 0 .454.454 0 0 0 0-.64zM4.165 3.316a.45.45 0 0 0-.637 0 .454.454 0 0 0 0 .64l1.275 1.28a.45.45 0 0 0 .638 0 .454.454 0 0 0 0-.64z"
      }),
      _createElementVNode("path", {
        fill: "#FFF3C1",
        d: "M6.54 11.774a.45.45 0 0 1-.452-.453c0-2.997 2.428-5.434 5.412-5.434a.45.45 0 0 1 .451.453c0 .25-.202.452-.451.452-2.487 0-4.51 2.032-4.51 4.529 0 .25-.201.453-.45.453"
      }),
      _createElementVNode("path", {
        fill: "#4B4D56",
        d: "M9.245 19.472v3.17h.902V24h2.706v-1.358h.902v-3.17z"
      })
    ], -1)
  ]))]))
}
export default { render: render }